export default __webpack_public_path__ + "static/media/ico-warning-outline.db6cd64e.svg";